// product-form.js — StateDecal
// <product-form> Web Component: variant selection, AJAX add-to-cart, price updates

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.submitBtn = this.querySelector('[data-add-to-cart]');
    this.variantInput = this.querySelector('#variant-id');
    this.priceEl = document.getElementById('product-price');
    this.cartCountEl = document.querySelector('.header__cart-count');
    this.cartIconBtn = document.querySelector('.header__cart-btn');

    // Parse variant data
    var jsonEl = this.querySelector('#product-variants-json');
    this.variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    this.currentVariant = this.variants[0] || null;

    // Option button listeners
    this.querySelectorAll('[data-variant-option]').forEach(function (btn) {
      btn.addEventListener('click', this.onOptionClick.bind(this));
    }.bind(this));

    // Quantity listeners
    var minusBtn = this.querySelector('[data-qty-minus]');
    var plusBtn = this.querySelector('[data-qty-plus]');
    this.qtyInput = this.querySelector('.product__qty-input');

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        var v = parseInt(this.qtyInput.value) || 1;
        if (v > 1) this.qtyInput.value = v - 1;
      }.bind(this));
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        var v = parseInt(this.qtyInput.value) || 1;
        this.qtyInput.value = v + 1;
      }.bind(this));
    }

    // Form submit
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  onOptionClick(e) {
    var btn = e.currentTarget;
    var group = btn.closest('[data-option-group]');

    // Update active state in this group
    group.querySelectorAll('[data-variant-option]').forEach(function (b) {
      b.classList.remove('product__option-btn--selected');
    });
    btn.classList.add('product__option-btn--selected');

    // Update the selected value label
    var label = group.querySelector('[data-option-value]');
    if (label) label.textContent = btn.dataset.value;

    // Find matching variant
    var selectedOptions = [];
    this.querySelectorAll('[data-option-group]').forEach(function (grp) {
      var active = grp.querySelector('[data-variant-option].product__option-btn--selected');
      if (active) selectedOptions.push(active.dataset.value);
    });

    var matched = this.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
    });

    if (matched) {
      this.currentVariant = matched;
      this.updatePrice(matched);
      this.updateAvailability(matched);
      if (this.variantInput) this.variantInput.value = matched.id;
      history.replaceState({}, '', '?variant=' + matched.id);

      // Switch main image if variant has one
      if (matched.featured_image) {
        var mainImg = document.getElementById('product-main-image');
        if (mainImg) mainImg.src = matched.featured_image.src;
      }
    }
  }

  updatePrice(variant) {
    if (!this.priceEl) return;

    var price = this.formatMoney(variant.price);
    var html = '';

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var savings = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      html  = '<span class="price price--sale">' + price + '</span>';
      html += '<span class="price price--compare">' + this.formatMoney(variant.compare_at_price) + '</span>';
      html += '<span class="badge badge--sale">SAVE ' + savings + '%</span>';
    } else {
      html = '<span class="price">' + price + '</span>';
    }

    this.priceEl.innerHTML = html;
  }

  updateAvailability(variant) {
    if (!this.submitBtn) return;
    if (variant.available) {
      this.submitBtn.disabled = false;
      this.submitBtn.textContent = 'Add to Cart';
    } else {
      this.submitBtn.disabled = true;
      this.submitBtn.textContent = 'Sold Out';
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  onSubmit(e) {
    e.preventDefault();
    if (!this.currentVariant || !this.currentVariant.available) return;

    var qty = parseInt(this.qtyInput ? this.qtyInput.value : 1) || 1;
    this.submitBtn.disabled = true;
    this.submitBtn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: this.currentVariant.id, quantity: qty })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return fetch('/cart.js');
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      this.updateCartCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));
      document.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: {
          title: this.currentVariant.title || '',
          price: this.formatMoney(this.currentVariant.price)
        }
      }));
      this.submitBtn.textContent = 'Added!';
      setTimeout(function () {
        this.submitBtn.textContent = 'Add to Cart';
        this.submitBtn.disabled = false;
      }.bind(this), 2000);
    }.bind(this))
    .catch(function () {
      this.submitBtn.textContent = 'Error \u2014 Try again';
      this.submitBtn.disabled = false;
    }.bind(this));
  }

  updateCartCount(count) {
    if (!this.cartIconBtn) return;
    var existing = this.cartIconBtn.querySelector('.header__cart-count');
    if (count > 0) {
      if (existing) {
        existing.textContent = count;
      } else {
        var span = document.createElement('span');
        span.className = 'header__cart-count';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = count;
        this.cartIconBtn.appendChild(span);
      }
    } else if (existing) {
      existing.remove();
    }
  }
}

customElements.define('product-form', ProductForm);
